const AirpayResponse = () => {
    
    return (
        <>
        <h1>Payment Response Page</h1>
        </>
    )
}
export default AirpayResponse;